import { useState } from "react";
import { Sun, Moon } from "lucide-react";

export function applyTheme(t) {
  localStorage.setItem("konddo_theme", t);
  document.documentElement.classList.toggle("light", t === "light");
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(localStorage.getItem("konddo_theme") || "dark");
  const set = (t) => { setTheme(t); applyTheme(t); };
  return (
    <div className="glass rounded-3xl p-4 flex items-center justify-between" data-testid="theme-toggle">
      <div>
        <p className="text-sm font-semibold">Aparência</p>
        <p className="text-xs text-muted-foreground">Escolha o tema do KONDDO</p>
      </div>
      <div className="flex gap-1 rounded-full bg-white/5 border border-white/10 p-1">
        <button onClick={() => set("light")} data-testid="theme-light" className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${theme === "light" ? "brand-gradient text-white" : "text-muted-foreground"}`}><Sun className="w-3.5 h-3.5" /> Claro</button>
        <button onClick={() => set("dark")} data-testid="theme-dark" className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${theme === "dark" ? "brand-gradient text-white" : "text-muted-foreground"}`}><Moon className="w-3.5 h-3.5" /> Escuro</button>
      </div>
    </div>
  );
}
